import { Injectable } from '@angular/core';

import { BaseApiService } from '~app-client/api/_internal';
import { ReachNodeId } from '~app-client/core/types';

@Injectable({ providedIn: 'root' })
export class ImportApiService extends BaseApiService {
	protected commonPath = [''];

	public async import(file: File): Promise<void> {
		const formData = new FormData();
		formData.append('file', file);

		return await this.http.post<void>(this.url('import'), formData, { i: JSON.stringify({}) });
	}

	public async exportWorkspaces(
		workspacesIds: ReachNodeId[],
		unassigned: boolean,
		trashed: boolean
	): Promise<void> {
		const body = {
			workspaceIds: workspacesIds,
			includeUnassignedNodes: unassigned,
			includeTrashNodes: trashed,
		};
		return await this.http.post<void>(this.url('export', 'workspaces'), body);
	}
}
